<template>
  <div>
    <v-autocomplete
      v-if="!loading"
      v-model="selectedSetlistIds"
      color="secondary"
      :items="setlists"
      item-text="name"
      item-value="id"
      :label="label"
      multiple hide-selected
      :menu-props="{ closeOnContentClick: true }"
      :hint="hint"
      :persistent-hint="persistentHint">
      <template #selection="{ item }">
        <v-chip
          :color="color"
          close small
          @input="deleteChip(item)">
          {{item.name}}
        </v-chip>
      </template>
    </v-autocomplete>
    <span v-else>Loading setlist selector...</span>
  </div>
</template>

<script>
export default {
  name: 'setlist-selector',
  props: {
    modelProp: Array,
    excludedIds: {
      type: Array,
      default () { return [] }
    },
    name: String,
    label: String,
    hint: String,
    persistentHint: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  data () {
    return {
      loading: true,
      selectedSetlistIds: [],
      allSetlists: []
    }
  },
  created () {
    this.$api.setlists.all().then(setlists => {
      this.allSetlists = setlists
      this.loading = false
    })
    this.selectedSetlistIds = this.modelProp
  },
  computed: {
    setlists () {
      return this.allSetlists.filter(s => {
        return !this.excludedIds.includes(s.id)
      })
    }
  },
  methods: {
    deleteChip (item) {
      var index = this.selectedSetlistIds.indexOf(item.id)
      if (index < 0) return

      this.selectedSetlistIds.splice(index, 1)
    }
  },
  watch: {
    selectedSetlistIds (val) {
      this.$emit('update', val)
    }
  }
}

</script>
